import React from 'react';
import { useTheme } from 'styled-components';
import type CSS from 'csstype';

import { ArrowLinkButtonProps } from 'Elements/Button/Arrow';

import ImageHeroBanner, { HeroBannerImageProps } from '../';

import { Content, Heading, HeadingPre, HeadingMain, StyledArrowButton } from './Course.styled';

export interface Props
    extends Omit<HeroBannerImageProps, 'inner' | 'backgroundColour' | 'textColour'> {
    preHeading?: string;
    heading: string;
    applyButton?: ArrowLinkButtonProps;
    backgroundColour?: CSS.Property.BackgroundColor;
}

const Course: React.FC<Props> = props => {
    const { colors } = useTheme();
    const {
        preHeading,
        heading,
        applyButton,
        backgroundColour = colors.tertiary.hex,
        ...rest
    } = props;

    return (
        <ImageHeroBanner {...rest} backgroundColour={backgroundColour} imageQuality={100}>
            <Content>
                <Heading>
                    <HeadingPre>{preHeading}</HeadingPre>
                    <HeadingMain>{heading}</HeadingMain>
                </Heading>
                {applyButton && <StyledArrowButton {...applyButton} />}
            </Content>
        </ImageHeroBanner>
    );
};

export default Course;
